'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _LibraryNavSidebar = require('@quixeltools/quixel-ui-library/dist/components/megascans/library/LibraryNavSidebar');

var _LibraryNavSidebar2 = _interopRequireDefault(_LibraryNavSidebar);

var _libraryNav = require('utils/libraryNav');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var browseLinks = function browseLinks(loggedIn, acquired, favorites, notSeen, userFreeDrops) {
  return loggedIn ? [{ label: 'Latest', to: '/megascans/library/latest' }, { label: 'Free', to: '/megascans/library/free', count: userFreeDrops + 50, indicator: notSeen }, { label: 'Acquired', to: '/megascans/library/myscans', count: acquired }, { label: 'Favorites', to: '/megascans/library/favorited', count: favorites }] : [{ label: 'Latest', to: '/megascans/library/latest' }, { label: 'Free', to: '/megascans/library/free', count: userFreeDrops + 50, indicator: notSeen }];
};
var browseLinksForArchviz = function browseLinksForArchviz(loggedIn, acquired, favorites, notSeen, userFreeDrops) {
  return loggedIn ? [{ label: 'Latest', to: '/megascans/library/archviz/latest' }, { label: 'Free', to: '/megascans/library/archviz/free', count: userFreeDrops + 50, indicator: notSeen }, { label: 'Acquired', to: '/megascans/library/archviz/myscans', count: acquired }, { label: 'Favorites', to: '/megascans/library/archviz/favorited', count: favorites }] : [{ label: 'Latest', to: '/megascans/library/archviz/latest' }, { label: 'Free', to: '/megascans/library/archviz/free', count: userFreeDrops + 50, indicator: notSeen }];
};

var dropdownFromData = function dropdownFromData(dropdownLabel) {
  return _ramda2.default.compose(_ramda2.default.prepend({
    name: 'All ' + dropdownLabel,
    value: 'all'
  }), _ramda2.default.map(function (datum) {
    return { name: datum.label, value: datum.slug };
  }));
};

var getValue = function getValue(query, key) {
  return query[key] || 'all';
};

var createQueryTo = function createQueryTo(query, key, val, exclude) {
  return {
    pathname: '/megascans/library',
    query: (0, _libraryNav.createQuery)(query, key, val, exclude)
  };
};

var createQueryToCollection = function createQueryToCollection(pathname, query, key, val, exclude) {
  return {
    pathname: pathname,
    query: (0, _libraryNav.createQuery)(query, key, val, exclude)
  };
};

var curatedFacetstype = [{ label: '3D', slug: '3d', count: 284 }, { label: 'Atlases', slug: 'atlas', count: 1743 }, { label: 'Surfaces', slug: 'surface', count: 1653 }];

var LibraryNavSidebarContainer = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(LibraryNavSidebarContainer, _React$Component);

  function LibraryNavSidebarContainer() {
    (0, _classCallCheck3.default)(this, LibraryNavSidebarContainer);
    return (0, _possibleConstructorReturn3.default)(this, (LibraryNavSidebarContainer.__proto__ || (0, _getPrototypeOf2.default)(LibraryNavSidebarContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(LibraryNavSidebarContainer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          packs = _props.packs,
          facets = _props.facets,
          loggedIn = _props.loggedIn,
          acquired = _props.acquired,
          favorites = _props.favorites,
          categoryTree = _props.categoryTree,
          user = _props.user;
      var router = this.context.router;
      var _router$location = router.location,
          query = _router$location.query,
          pathname = _router$location.pathname,
          collectionType = router.params.collectionType;


      var isArchviz = pathname.indexOf('library/archviz') > -1;

      var type = query.type,
          category = query.category,
          subCategory = query.subCategory;


      var indexOfAll = -1;
      for (var i = 0; i < categoryTree.length; i++) {
        if (categoryTree[i].label !== 'all') {
          categoryTree[i].to = isArchviz ? createQueryToCollection('/megascans/library/archviz', query, 'category', categoryTree[i].label, ['subCategory']) : createQueryTo(query, 'category', categoryTree[i].label, ['subCategory']);
          var subCategories = categoryTree[i].subCategories;
          if (subCategories) {
            for (var j = 0; j < subCategories.length; j++) {
              subCategories[j].to = isArchviz ? createQueryToCollection('/megascans/library/archviz', query, 'subCategory', subCategories[j].label) : createQueryTo(query, 'subCategory', subCategories[j].label);
            }
          }
        } else {
          indexOfAll = i; // save index of All to put it on top of category tree
          categoryTree[i].to = {
            pathname: isArchviz ? '/megascans/library/archviz' : '/megascans/library',
            query: {}
          };
        }
      }

      if (indexOfAll > 0) {
        var replacement = categoryTree[0];
        categoryTree[0] = categoryTree[indexOfAll];
        categoryTree[indexOfAll] = replacement;
      }

      var _curatedCollections = [];
      packs.forEach(function (pack) {
        var _curatedCollection = _ramda2.default.find(_ramda2.default.propEq('label', pack.type))(_curatedCollections);
        if (!_curatedCollection) {
          _curatedCollection = {
            label: pack.type,
            count: 0,
            to: { pathname: isArchviz ? '/megascans/library/archviz/collections/' + pack.type : '/megascans/library/collections/' + pack.type },
            subCategories: []
          };
          _curatedCollections.push(_curatedCollection);
        }
        _curatedCollection.count++;

        _curatedCollection.subCategories.push({
          label: pack.name,
          slug: pack.name,
          id: pack.id,
          count: pack.assets,
          to: isArchviz ? '/megascans/library/archviz/collections/' + pack.type + '/' + pack.id : '/megascans/library/collections/' + pack.type + '/' + pack.id
        });
      });

      var notSeen = false;
      var userFreeDrops = 0;

      if (user && user.loaded && user.drops) {
        if (_underscore2.default.isEmpty(user.drops) || !!user.drops.seen) {
          notSeen = false;
        } else {
          notSeen = true;
        }
        if (user.drops.assetIds && user.drops.assetIds.length) {
          userFreeDrops = user.drops.assetIds.length;
        }
      }

      var mainLinks = isArchviz ? browseLinksForArchviz(loggedIn, acquired, favorites, notSeen, userFreeDrops) : browseLinks(loggedIn, acquired, favorites, notSeen, userFreeDrops);

      var listData = [{
        key: 'browse',
        label: 'Browse',
        list: mainLinks,
        current: type
      }, {
        key: 'curated content',
        label: 'Curated Content',
        list: _curatedCollections,
        current: collectionType
      }, {
        key: 'categories',
        label: 'Categories',
        list: categoryTree,
        current: query.category
      }];

      listData = _ramda2.default.reject(function (n) {
        return (isArchviz || loggedIn && user.subscription && user.subscription.isArchViz) && (n.label === 'Curated Content' || n.key == 'curated content');
      }, listData);

      return _react2.default.createElement(_LibraryNavSidebar2.default, {
        isArchviz: isArchviz,
        assetTypes: dropdownFromData('types')(curatedFacetstype || []),
        onAssetTypeChange: (0, _libraryNav.dropdownChangeHandler)(isArchviz ? '/megascans/library/archviz' : '/megascans/library', router, query, 'type'),
        currentAssetType: getValue(query, 'type'),
        listData: listData
      });
    }
  }]);
  return LibraryNavSidebarContainer;
}(_react2.default.Component), _class.contextTypes = {
  router: _react2.default.PropTypes.object
}, _class.defaultProps = {
  facets: {}
}, _temp);
exports.default = LibraryNavSidebarContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LibraryNavSidebar/LibraryNavSidebar.jsx
// module id = 2776
// module chunks = 0